module.exports = __webpack_public_path__ + "img/10_Holzindustriefachmann_Foto.2a05ce8e.jpg";